'use strict';

require('fancybox');
require('../publications/CompanyPublicationService.js');

require("./CompanyPublicationActivity.js");
require("./CompanyPublicationActivityDirective.js");
require("./CompanyPublicationWallDirective.js");
require("./CompanyEsignActivityDirective.js");
require("./PublicationSettingsDirective.js");
require('./companyOrder/CompanyPublicationCompanyOrderService.js');
require('../settings/CompanySettingUnitsService.js');
require('./CompanyPublicationEsignService.js');
require('../projects/CompanyAddContactsCtrl.js');
require('../notes/CompanyNoteService.js');
require('../../company/order-type/CompanyOrderTypeService.js');
var moment = require('moment');

CompanyPublicationCtrl.$inject = [
  '$scope',
  '$rootScope',
  '$stateParams',
  '$filter',
  '$modal',
  '$translate',
  'publication',
  'investigation',
  'children',
  'priorities',
  'notes',
  'activityService',
  'CompanyPublicationFileService',
  'CompanyPublicationService',
  'CompanyPublicationCompanyOrderService',
  'CompanyProjectService',
  'CompanyOrderTypeService',
  'CompanySettingUnitsService',
  'CompanyPublicationCompanyOrderSubcriptionService',
  'CompanyPublicationCompanyInvestigationService',
  'CompanyPublicationEsignService',
  'CompanyNoteService',
  'growl',
  'translations',
  'config',
  '$http',
  '$q',
  '$state',
  'initialActivity'/* Here to wait for it this to load */
];

function CompanyPublicationCtrl(
  $scope,
  $rootScope,
  $stateParams,
  $filter,
  $modal,
  $translate,
  publication,
  investigation,
  children,
  priorities,
  notes,
  activityService,
  CompanyPublicationFileService,
  CompanyPublicationService,
  publicationCompanyOrderService,
  CompanyProjectService,
  CompanyOrderTypeService,
  CompanySettingUnitsService,
  publicationCompanyOrderSubcriptionService,
  CompanyPublicationCompanyInvestigationService,
  CompanyPublicationEsignService,
  CompanyNoteService,
  growl,
  translations,
  config,
  $http,
  $q,
  $state) {
  $scope.showPortalTab          = true;
  $scope.showChildrentab        = false;
  $scope.showVersionsTab        = $scope.currentUserPermissions.CompanySeeFileVersion ? (publication.versionNumber > 1 ? true : false) : false;
  $scope.showShareTab           = $scope.info.features.shareObject;
  $scope.activityService        = activityService;
  $scope.showOrderReport        = false;
  $scope.showPlantReport        = false;
  $scope.notes                  = notes;
  $rootScope.investigationInfors = [];

  if(publication.type === 'FORM'){
    if (
      publication.features.formActived === "false" ||
      !!publication.features.formActived === false
    ) {
      window.location.href = '/forms/companies/'+$stateParams.companyId+'/publications/'+publication.id+'/detail';
    }else{
      window.location.href = '/forms/companies/'+$stateParams.companyId+'/publications/'+publication.id+'/form-submit';
    }
  }
  if(publication.type === 'PUBLICATION_SPREAD_SHEET'){
    window.location.href = '/spreadsheet/'+$stateParams.companyId+'/publications/'+publication.id;
  }
  if(publication.type === 'COMPANY_ORDER'){
    window.location.href = '/order/'+$stateParams.companyId+'/detail/'+publication.id;
  }
  if(publication.type === 'ORDER_SUBCRIPTION'){
    window.location.href = '/order/'+$stateParams.companyId+'/subcription-detail/'+publication.id;
  }

  if(publication.type === 'DEFAULT' && $scope.info.features.esign){
    $scope.newEsign = {
      publication: publication,
      active: true,
      deadline: moment(new Date()).add(30, 'day'),
      extra: {
        emails: []
      }
    };
    $scope.toggleCreateEsign = false;
    CompanyPublicationEsignService.query({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      limit: 1
    }).$promise.then(function(esigns){
      if(esigns.length){
        $scope.newEsign = esigns[0];
        $scope.toggleCreateEsign = true;
      }
    });

    $scope.newUser = {
      name: '',
      email: '',
      phone: '',
      company: ''
    };

    $scope.addEsignEmail = function(){
      $scope.newEsign.extra.emails.push($scope.newUser); 
      $scope.newUser = {
        name: '',
        email: '',
        phone: '',
        company: ''
      };
    };

    $scope.fillMyInfo = function(){
      $scope.newUser = {
        name: $scope.currentUser.name,
        email: $scope.currentUser.email,
        phone: $scope.currentUser.contacts.mobilePhone,
        company: $scope.info.Name
      };
    };

    $scope.addContact = function(newContact){
      $scope.newUser = {
        name: newContact.contactName,
        email: newContact.contactEmail,
        phone: newContact.contactPhone,
        company: newContact.contactWeb
      };
    };

    $scope.showModalAddContacts = function(){
      var modal = $modal({
        scope: $scope,
        controller: 'CompanyAddContactsCtrl',
        templateUrl: 'partials/company/projects/modal-add-contacts.html',
        show: false,
        resolve: {
          contacts: ['$stateParams', 'CompanyAddressBookService', function($stateParams, CompanyAddressBookService) {
            return CompanyAddressBookService.query({companyId: $stateParams.companyId, limit: 20}).$promise;
          }]
        }
      });

      modal.$promise.then(function(){
        modal.show();
      });
    }

    $scope.resend = function(){
      CompanyPublicationEsignService.update({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, eSignId: $scope.newEsign.ID}, $scope.newEsign, function() {
        growl.addSuccessMessage($translate.instant('publication.resent-esign-success'));
      }, function() {
        growl.addErrorMessage($translate.instant('publication.resent-esign-failure'));
      });
    };

    $scope.createEsign = function(){
      if(!$scope.newEsign.ID){
        $scope.newEsign.sharedBy = $scope.currentUser;
        CompanyPublicationEsignService.save({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}, $scope.newEsign, function(res) {
          $scope.newEsign = res;
          growl.addSuccessMessage($translate.instant('publication.created-esign-success'));
        }, function() {
          growl.addErrorMessage($translate.instant('publication.created-esign-failure'));
        });
      }else{
        CompanyPublicationEsignService.update({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}, $scope.newEsign, function() {
          growl.addSuccessMessage($translate.instant('publication.canceled-esign-success'));
        }, function() {
          growl.addErrorMessage($translate.instant('publication.canceled-esign-failure'));
        });
      }
    };
  }

  $scope.order = false;
  if(publication.type === 'COMPANY_ORDER' || publication.type === 'ORDER_SUBCRIPTION'){
    $scope.paymentTypes = [
      {
        'name': translations['order.payment.cash-on-delivery'],
        'value': 'CASH_ON_DELIVERY'
      }, {
        'name': translations['order.payment.10-days'],
        'value': '10_DAYS'
      }, {
        'name': translations['order.payment.20-days'],
        'value': '20_DAYS'
      }, {
        'name': translations['order.payment.30-days'],
        'value': '30_DAYS'
      }
    ];

    CompanySettingUnitsService.query({
      companyId: $stateParams.companyId,
      limit: 1000
    }, function(resp){
      $scope.units = resp;
    });

    CompanyOrderTypeService.query({
      companyId: $stateParams.companyId,
      limit: 1000
    }, function(orderTypes){
      $scope.orderTypes = orderTypes;
    });

    $q.all(CompanyProjectService.query({
      companyId: $stateParams.companyId,
      limit: 1000
    }, function(resp){
      $scope.projects = resp;
    })).then(function(){
      if (publication.features.currentCompanyOrderId) {
        var order, dataOrder;
        if(publication.type === 'COMPANY_ORDER'){
          order = angular.copy(publicationCompanyOrderService);
          dataOrder = {
            companyId: $stateParams.companyId,
            publicationId: $stateParams.publicationId,
            orderId: publication.features.currentCompanyOrderId
          };
        }else{
          order = angular.copy(publicationCompanyOrderSubcriptionService);
          dataOrder = {
            companyId: $stateParams.companyId,
            publicationId: $stateParams.publicationId,
            subcriptionId: publication.features.currentCompanyOrderId
          };
        }
        order.get(dataOrder).$promise.then(function(order){
          $scope.order = order;
          $scope.showCustomerInfo = true;
          if(publication.type === 'ORDER_SUBCRIPTION'){
            var subcription            = $scope.order.interval.split(' ');
            $scope.order.subcriptionNumber   = parseInt(subcription[0]);
            $scope.order.optionSubcription   = subcription[1][subcription[1].length-1] === 's' ? subcription[1].substring(0, subcription[1].length-1) : subcription[1];
            if(!$scope.order.lastGenAt){
              $scope.order.lastGenAt = $scope.order.createdAt;
            }
            if($scope.order.startAt >= $scope.order.lastGenAt){
              $scope.order.nextCreatedOrder = moment($scope.order.startAt).add(parseInt($scope.order.subcriptionNumber), $scope.order.optionSubcription+($scope.order.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY-MM-DD');
            }else{
              $scope.order.nextCreatedOrder = moment($scope.order.lastGenAt).add(parseInt($scope.order.subcriptionNumber), $scope.order.optionSubcription+($scope.order.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY-MM-DD');
            }
          }

          updateTotal();
          $scope.filterPriceListName();
        });
      }else{
        $scope.filterPriceListName();
      }
    });

    $scope.filterPriceListName = function() {
      if($scope.order && $scope.order.customer && $scope.order.customer.priceList !== null){
        $scope.currentProject = $scope.order.customer.priceList;
      }else{
        if ($scope.order.project && $scope.order.project.id && $scope.projects) {
          var currentProject = $scope.projects.filter(function(project){
            return project.id === $scope.order.project.id;
          });

          if (currentProject.length > 0) {
            $scope.currentProject = currentProject[0].price_list;
          }
        }
      }
    };

    $scope.setDefautPricelist = function(order) {
      $scope.order = order;
      $scope.filterPriceListName();
      if (($scope.order.project && $scope.order.project.id) || ($scope.order.customer && $scope.order.customer.priceList !== null)) {
        angular.forEach($scope.order.items ,function(v){
          if (v.price.priceListId !== $scope.currentProject.id) {
            angular.forEach(v.product.pricelist, function(p){
              if ($scope.currentProject.id === p.priceListId) {
                v.price = angular.copy(p);
                v.price.soldPrice = v.price.price;
                if($scope.publication.type === 'ORDER_SUBCRIPTION'){
                  publicationCompanyOrderSubcriptionService.updateItem({
                    companyId: $stateParams.companyId,
                    publicationId: $stateParams.publicationId,
                    subcriptionId: $scope.order.id,
                    itemId: v.id
                  }, v);
                }else{
                  publicationCompanyOrderService.updateItem({
                    companyId: $stateParams.companyId,
                    publicationId: $stateParams.publicationId,
                    orderId: $scope.order.id,
                    itemId: v.id
                  }, v);
                }
              }
            });
          }
        });
      }
      updateTotal();
      $scope.$broadcast('orderChanged', $scope.order);
    };

    var totalOrder = function(includeTax) {
      var total = 0;
      if ($scope.order) {
        angular.forEach($scope.order.items, function(v){
          if (includeTax) {
            total += v.price.soldPrice * v.amount + v.price.soldPrice * v.amount * v.price.tax / 100;
          } else {
            total += v.price.soldPrice * v.amount;
          }
        });
      }

      return total;
    };

    var updateTotal =  function() {
      $scope.totalExcludeTax = totalOrder();
      $scope.totalIncludeTax = totalOrder(true);
      $scope.totalTax        = totalOrder(true) - totalOrder();
    };

    $scope.updateTotal = updateTotal;

    $scope.update = function(order) {
      var o = angular.copy(order);
      if(o.customerOrderNr === ''){
        o.customerOrderNr = null;
      }
      if(publication.type === 'ORDER_SUBCRIPTION'){
        o.interval = o.subcriptionNumber + ' ' + o.optionSubcription + (o.subcriptionNumber > 1 ? 's' : '');
      }
      o.$update({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId
      }, function(){
        growl.addSuccessMessage(translations['order.update-success']);
        if(publication.type === 'ORDER_SUBCRIPTION'){
          var subcription            = o.interval.split(' ');
          o.subcriptionNumber   = parseInt(subcription[0]);
          o.optionSubcription   = subcription[1][subcription[1].length-1] === 's' ? subcription[1].substring(0, subcription[1].length-1) : subcription[1];
          if(!o.lastGenAt){
            o.lastGenAt = o.createdAt;
          }
          if(o.startAt >= o.lastGenAt){
            o.nextCreatedOrder = moment(o.startAt).add(parseInt(o.subcriptionNumber), o.optionSubcription+(o.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY-MM-DD');
          }else{
            o.nextCreatedOrder = moment(o.lastGenAt).add(parseInt(o.subcriptionNumber), o.optionSubcription+(o.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY-MM-DD');
          }
        }
        $scope.$broadcast('orderChanged', o);
      }, function(){
        growl.addErrorMessage(translations['order.update-failure']);
      });
    };

    $scope.createNextOrder = function(){
      publicationCompanyOrderSubcriptionService.createNextOrder({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        subcriptionId: $scope.order.id
      }, {}, function(){
        growl.addSuccessMessage(translations['order.create-next-order-success']);
      }, function(){
        growl.addErrorMessage(translations['order.create-next-order-failure']);
      });
    };

    $scope.createAllCopies = function(orderCopies){
      publicationCompanyOrderService.copyOrder({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        orderId: $scope.order.id
      }, orderCopies, function(){
        growl.addSuccessMessage(translations['order.create-all-copies-success']);
        angular.element('.filterDate').val('');
      }, function(){
        growl.addErrorMessage(translations['order.create-all-copies-failure']);
      });
    };
  }

  if(publication.type === 'INVESTIGATION'){
    $scope.activeTab = 0;
    $scope.investigation = investigation;
    $scope.investigationSteps = [{
      name: translations['investigation.parter-and-information'],
      template: 'partials/company/publications/investigation/parter-information.html',
      success: false
    },{
      name: translations['investigation.statement'],
      template: 'partials/company/publications/investigation/statement.html',
      success: false
    },{
      name: translations['investigation.summary'],
      template: 'partials/company/publications/investigation/summary.html',
      success: false
    },{
      name: translations['investigation.decision'],
      template: 'partials/company/publications/investigation/decision.html',
      success: false
    }];

    var queryFiles =  function() {
      return CompanyPublicationFileService.query({
        companyId:     $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        limit:         21,
        visible:       $stateParams.showInvisible === "true" ? "false" : "true",
        offset:        ($stateParams.page|0) * 20
      }).$promise.then(function(files) {
        $scope.$emit('publicationSaved');
        $scope.files   = files.slice(0, 20);
        $scope.hasMore = files.length > 20;
      });
    };

    CompanyPublicationFileService.query({
      companyId:     $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      limit:         22,
      visible:       $stateParams.showInvisible === "true" ? "false" : "true",
      offset:        ($stateParams.page|0) * 21,
      q:             $stateParams.searchFile || "",
      searchAble: true
    }).$promise.then(function(files){
      $scope.files = files;
      $scope.hasMore = files.length > 21;
      $scope.$on("files-uploaded", queryFiles);
    });

    $scope.setReminderDate = function(investigationAtgardInfor){
      var indexInvesAtgardInfor = $scope.investigationAtgardInfors.indexOf(investigationAtgardInfor);
      var varnadNumber = investigationAtgardInfor.periodUp.split(' ');
      $scope.investigationAtgardInfors[indexInvesAtgardInfor].lastDate = moment(investigationAtgardInfor.varnadDate).add(parseInt(varnadNumber[0]), ((varnadNumber[1] === 'mon' || varnadNumber[1] === 'mons') ? 'months' : varnadNumber[1])).format('YYYY-MM-DD');
      $scope.investigationAtgardInfors[indexInvesAtgardInfor].reminderDate = moment($scope.investigationAtgardInfors[indexInvesAtgardInfor].lastDate).subtract(3, 'days').format('YYYY-MM-DD');
    };

    CompanyPublicationCompanyInvestigationService.queryInvestigationInfors({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      limit: 100,
      offset: 0,
      type: 'ATGARD'
    }).$promise.then(function(investigationAtgardInfors){
      $scope.investigationAtgardInfors = investigationAtgardInfors;
      if(investigationAtgardInfors.length === 0){
        $scope.createNewInvestigationAtGardInfor();
      }else{
        angular.forEach(investigationAtgardInfors, function(value, key){
          $scope.investigationSteps.push({
            name: translations['investigation.action-and-follow-up'],
            template: 'partials/company/publications/investigation/action-and-follow-up.html',
            success: (key < investigationAtgardInfors.length-1 ? true : (investigation.status === 'DONE' ? ((value.followUpDate && value.followUpContent) ? true : false) : false))
          });
          if(value.followUpDate && value.followUpContent){
            $scope.investigationAtgardInfors[key].savedFollowUp = true;
          }else{
            $scope.investigationAtgardInfors[key].savedFollowUp = false;
          }
          $scope.setReminderDate(value);
        });
      }
    });

    $scope.beslutSigned = false;
    if($scope.investigation.beslutSign && $scope.investigation.beslutSign !== ''){
      $scope.investigationSteps[3].success = true;
    }
    $scope.drawSign = function(){
      if($scope.investigation.beslutSign && $scope.investigation.beslutSign !== ''){
        var c = document.getElementById("beslutSign");
        var ctx = c.getContext("2d");
        var imageObj = new Image();
        imageObj.onload = function() {
          ctx.drawImage(this, 0, 0);
        };
        imageObj.src = $scope.investigation.beslutSign;
        $scope.beslutSigned = true;
      }
    };

    $scope.nextStepInvestigation = function(activeTab){
      var isMarked = true;
      var activeTabLength = activeTab < 4 ? activeTab : 4;
      for(var i=0; i<activeTabLength;i++){
        if($scope.investigationSteps[i].success === false){
          isMarked = false;
          break;
        }
      }
      if(isMarked || activeTab === $scope.investigationSteps.length){
        $scope.activeTab = activeTab;
      }
      if(activeTab >= 4){
        if(!$scope.investigationAtgardInfors[activeTab-4].content){
          $scope.publicationActionFollowUpToggle = true;
        }else{
          $scope.publicationActionFollowUpToggle = false;
        }
      }
      if(activeTab === 3){
        if(!$scope.investigation.beslutSign){
          $scope.publicationDecisionToggle = true;
        }
        setTimeout(function(){
          $scope.drawSign();
        }, 1);
      }
      if(activeTab === 1 && !$rootScope.investigationInfors.length){
        $scope.publicationAccountToggle = true;
        $scope.newInvestigationInfor = {
          type: 'REDOGO',
          partner: '',
          periodUp: '14 days',
          telephoneMode: false,
          personlightMode: false,
          varnadDate: new Date(),
          content: '',
          extra: {
            selectdPart1: [],
            selectdPart2: []
          }
        };
      }
    };

    $scope.createNewInvestigationAtGardInfor = function(){
      var investigationInfor = {
        type: 'ATGARD',
        content: '',
        varnadDate: new Date(),
        periodUp: '14 days',
        partner: 'default',
        extra: {
          selectdPart1: [],
          selectdPart2: []
        }
      };
      CompanyPublicationCompanyInvestigationService.addInvestigationInfor({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId
      }, investigationInfor, function(resp){
        growl.addSuccessMessage(translations['investigation.save-investigation-infor-success']);
        $scope.investigationAtgardInfors.push(resp);
        $scope.investigationSteps.push({
          name: translations['investigation.action-and-follow-up'],
          template: 'partials/company/publications/investigation/action-and-follow-up.html',
          success: false
        });
        if($scope.investigationAtgardInfors.length > 1){
          $scope.activeTab = $scope.investigationSteps.length-1;
          $scope.publicationActionFollowUpToggle = true;
          $scope.investigationSteps[$scope.investigationSteps.length-2].success = true;
        }
        $scope.setReminderDate(resp);
      }, function(){
        growl.addErrorMessage(translations['investigation.save-investigation-infor-failure']);
      });
    };
  }

  $scope.openModalCreateNote = function(note){
    $rootScope.loading = true;
    var modal = $modal({
      scope: $scope,
      templateUrl: 'partials/company/publications/modal-update-note.html',
      show: false,
      controller: ['$scope', '$stateParams', function($scope, $stateParams){
        if(note){
          $scope.note = note;
        }else{
          $scope.note = {
            note: "",
            visible: true,
            color: 0,
            objectRelativeType: "PUBLICATION",
            objectRelativeId: $stateParams.publicationId,
            companyId: $stateParams.companyId
          };
        }

        $scope.saveNote = function(){
          CompanyNoteService.update({companyId: $stateParams.companyId}, $scope.note, function(resp) {
            if(!note){
              $scope.notes.push(resp);
            }else{
              var noteIndex = $scope.notes.filter(function(n){
                return n.id === $scope.note.id;
              });
              $scope.notes[$scope.notes.indexOf(noteIndex[0])] = resp;
            }
            growl.addSuccessMessage($translate.instant('save-note-success'));
          }, function() {
            growl.addErrorMessage($translate.instant('save-note-failure'));
          });
        };

        $scope.deleteNote = function(){
          CompanyNoteService.delete({companyId: $stateParams.companyId, noteId: $scope.note.id}, function() {
            var noteIndex = $scope.notes.findIndex(function(n){
              return n.id === $scope.note.id;
            });
            $scope.notes.splice(noteIndex, 1);
            growl.addSuccessMessage($translate.instant('delete-note-success'));
          }, function() {
            growl.addErrorMessage($translate.instant('delete-note-failure'));
          });
        };
      }]
    });
    modal.$promise.then(function(){
      modal.show();
      $rootScope.loading = false;
    });
  };

  switch(publication.type) {
    case 'ALBUM':
      $scope.showVersionsTab = false;
      break;

    case 'FOLDER':
      $scope.showVersionsTab = false;
      break;

    case 'NOTE':
      $scope.showVersionsTab  = false;
      break;

    case 'KEYPASS':
      $scope.showShareTab = false;
      break;

    case 'MASTERFILE':
      $scope.showShareTab = false;
      $scope.showVersionsTab = false;
      break;

    case 'WALL':
      $scope.showShareTab = false;
      $scope.showVersionsTab = false;
      break;

    case 'ORDER':
      $scope.showOrderReport = publication.features.currentOrderId;
      $scope.showVersionsTab = false;
      $scope.showShareTab = false;
      break;

    case 'CUSTOMER_ADAPTION':
      $scope.showVersionsTab = false;
      break;

    case 'PUBLICATION_GROUP':
      break;

    case 'PLANT':
      $scope.showPlantReport = publication.features.currentPlantId;
      break;
    case 'COMPANY_ORDER':
    case 'ORDER_SUBCRIPTION':
      $scope.showShareTab = false;
      $scope.showVersionsTab = false;
      break;
    case 'BLOG':
      $scope.showShareTab = false;
      $scope.showVersionsTab = false;
      break;
    case 'INVESTIGATION':
      $scope.showShareTab = false;
      $scope.showVersionsTab = false;
      break;
    case 'SK3_FOLDER':
      $scope.showVersionsTab = false;
      break;
  }

  if(children.length > 0) {
    $scope.showChildrenTab = true;
  }


  $scope.onFileSelect = function($files) {
    if (!$scope.publication.uploadLock || $scope.publication.uploadLock.id === $scope.currentUser.id || ($scope.publication.type === 'MASTERFILE' && $scope.currentUserPermissions.CompanyPublicationMasterFileAllowedToOverride)) {
      var i = 0;
      function queue(){
        var uploadDeferred = $q.defer();
        var filesDeferred = $q.defer();
        var uploadFiles = [];
        var start = i;
        for(var j=start; j<(start+1); j++){
          if(i < $files.length){
            uploadFiles.push($files[j]);
            i++;
          }
          filesDeferred.resolve();
        }
        filesDeferred.promise.then(function(){
          $scope.uploadFilesForPublication(uploadFiles, $stateParams.publicationId).then(function(files) {
            publication.versionNumber += files.length;

            if(['FORM', 'NOTE', 'ALBUM', 'CUSTOMER_ADAPTION', 'MASTERFILE', 'FOLDER', 'SK3_FOLDER'].indexOf(publication.type) === -1) {
              $scope.showVersionsTab = $scope.currentUserPermissions.CompanySeeFileVersion ? (publication.versionNumber > 1 ? true : false) : false;
            }
            uploadDeferred.resolve();
          });
        });
        uploadDeferred.promise.then(function(){
          if(i < $files.length){
            queue();
          }else{
            $scope.$broadcast("files-uploaded");
            return true;
          }
        });
      }
      queue();
    } else {
      growl.addErrorMessage(translations['publication.file-upload-locked']);
      return false;
    }
  };

  $scope.setActivity = function(file){
    CompanyPublicationFileService.getShowFile({companyId: $stateParams.companyId, fileId: file.id});
  };

  $scope.openPreview = function(file, publicationId) {
    CompanyPublicationFileService.getFileToken({companyId: $stateParams.companyId, publicationId: publicationId, fileId: file.id}, {}, function(response) {
      if (['UNSUPPORTED', 'FAILED'].indexOf(file.previewStatus) > -1) {
        return $scope.download(file, publicationId);
      }

      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
      var url = config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token;

      var type;
      switch(file.mimeType) {
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
        case 'image/bmp':
        case 'image/svg+xml':
        case 'image/webp':
          type = 'image';
          break;
        case 'application/pdf':
          if (true === iOS) {
            window.open(url, '_self');
            return;
          }
          type = 'iframe';
          break;
        default:
          type = 'iframe';
      }

      jQuery.fancybox.open([{
        type: type,
        iframe: {
          preload: false
        },
        padding: 0,
        margin: 0,
        href: url
      }]);
    });

    return false;
  };

  $scope.download = function(file, publicationId) {
    CompanyPublicationFileService.getFileToken({companyId: $stateParams.companyId, publicationId: publicationId, fileId: file.id}, {}, function(response) {
      var additionParams = "";
      var checkoutInfo = [];
      additionParams = '&currentUserId=' + $scope.currentUser.id;
      var elm = angular.element(document.querySelector('body'));
      var iFrame = elm.find('#downloadWindow');
      if (!(iFrame && iFrame.length > 0)) {
        iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
        elm.append(iFrame);
      }

      iFrame.attr('src', config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token + '&download=true' + additionParams);

      if ($scope.publication.type === 'MASTERFILE') {
        var data = {};
        data.userId = $scope.currentUser.id;
        data.time = (new Date()).toISOString();
        checkoutInfo.push(data);
        $scope.publication.features.fileCheckout = JSON.stringify(checkoutInfo);
        $scope.savePublication($scope.publication).then(function(){
          CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise.then(function(resp){
            $scope.publication = resp;
            $scope.$$childHead.publication = resp;
          });
        });
      }
      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
      if (true === iOS) {
        window.open(config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token + '&download=true' + additionParams, '_self');
        return;
      }
    });
  };

  $scope.rotateImage = function(file, rotate) {
    var params = {
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      fileId: file.id,
      manipulate: 'rotate',
      rotate:     rotate
    };
    CompanyPublicationFileService.rotateImage(params, {}).$promise.then(function(){
      $scope.$broadcast("files-uploaded");
    });
  };

  $scope.deletePublication = function(publication) {
    $http({
      method: 'DELETE',
      url: config.apiBase + '/companies/' + $stateParams.companyId + '/publications/' + publication.id
    }).then(function() {

        growl.addSuccessMessage(translations['publication.remove-success']);

        if (publication.status === 'DRAFT') {
          $state.go('root.company.publications-listDrafts');
        }

        else if (publication.status === 'ARCHIVED') {
          $state.go('root.company.publications-listArchived');
        }

        else {
          $state.go('root.company.publications-list');
        }

    }, function() {
      growl.addErrorMessage(translations['publication.remove-failure']);
    });
  };

  $scope.dateFormat = function(d){
    return $filter('date')(d, "dd MMMM yyyy HH:mm");
  };

  $scope.unsetParent = function() {
    $scope.publication.parent = null;

    $scope.savePublication($scope.publication);
  };

  $scope.setParent = function(publication) {
    $scope.publication.parent = {
      id:   publication.id,
      name: publication.name
    };

    $scope.savePublication($scope.publication);
  };

  /* Aside: */
  $scope.publication = publication;

  if(!$scope.publication.extra.viewerPages){
    $scope.publication.extra.viewerPages = [];
    $scope.publication.extra.viewerPages.push({
      name: 'Start page',
      isStartPage: true,
      isEndPage: false,
      index: 0,
      content: ''
    });
    $scope.publication.extra.viewerPages.push({
      name: 'End page',
      isStartPage: false,
      isEndPage: true,
      index: 0,
      content: ''
    });
  }

  $scope.$on('publicationSaved', function(){
    $scope.publication.updatedAt = new Date();
  });
  $scope.priorities  = priorities;
}

CompanyPublicationCtrl.resolve = {
  /* For pretty much all of these we need to load company before actually
     sending an XHR to make sure we have permission (guest or normal user).
     This is because company will redicet if it is a guest. */
  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, fromPortal: $stateParams.fromPortal}).$promise;
  }],
  investigation: ['$stateParams', 'CompanyPublicationCompanyInvestigationService', function($stateParams, CompanyPublicationCompanyInvestigationService) {
    return CompanyPublicationCompanyInvestigationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  children: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.query({companyId: $stateParams.companyId, parentId: $stateParams.publicationId, limit: 6}).$promise;
  }],
  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
  }],
  initialActivity: ['activityService', function(activityService) {
    return activityService.next(0, 20, ["COMMENT"]);
  }],
  notes: ['$stateParams', 'CompanyNoteService', function($stateParams, CompanyNoteService) {
    return CompanyNoteService.query({
      companyId: $stateParams.companyId, 
      visible: true, 
      objectType: 'PUBLICATION', 
      objectID: $stateParams.publicationId,
      limit: 100
    }).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.file-upload-locked',
      'publication.lock-file-upload-success',
      'publication.lock-file-upload-failure',
      'order.payment.cash-on-delivery',
      'order.payment.10-days',
      'order.payment.20-days',
      'order.payment.30-days',
      'order.update-success',
      'order.update-failure',
      'order.create-all-copies-success',
      'order.create-all-copies-failure',
      'order.create-next-order-success',
      'order.create-next-order-failure',
      'investigation.parter-and-information',
      'investigation.statement',
      'investigation.summary',
      'investigation.decision',
      'investigation.action-and-follow-up',
      'investigation.save-investigation-infor-success',
      'investigation.save-investigation-infor-failure'
    ]);
  }]
};
module.exports = CompanyPublicationCtrl;

angular.module('dokiv')
  .controller('CompanyPublicationCtrl', CompanyPublicationCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationCtrl.js
// module id = 373
// module chunks = 0